<template>

<b-modal :id="modalId" @hidden="onHidden" @ok="$emit('save', project)" title="Nuevo Proyecto" size="lg" header-bg-variant="success" header-text-variant="light"
         ok-title="Guardar" ok-variant="success" cancel-title="Cancelar">
  <project-form ref="form" v-model="project"/>
</b-modal>

</template>

<script>

import ProjectForm from './ProjectForm'

export default {
  name: 'AddProjectModal',
  components: {ProjectForm},
  props: {
    modalId: {type: String, required: true}
  },
  data() {
    return {
      project: {}
    }
  },
  methods: {
    onHidden() {
      this.project = {}
      this.$refs.form.emptySelects()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/project/AddProjectModal.vue